import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Button, Spinner, Modal, ModalHeader, Container } from 'react-bootstrap';
import { getRandomThing } from '../features/thing/thingSlice';
import ItemExplainer from './ItemExplainer';
import { useSpeechSynthesis } from 'react-speech-kit';
import NewThingForm from './NewThingForm';
import { createThing } from '../features/thing/thingSlice';
import { toast } from 'react-toastify';

function Thing() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility

  const thing = useSelector((state) => state.thing.thing);
  const userCreator = useSelector((state) => state.thing.user);
  const user = useSelector((state) => state.auth.user)

  const handleGetRandomThing = async () => {
    setLoading(true);
    try {
      await dispatch(getRandomThing());
    } catch (error) {
      console.error('Error fetching random thing:', error);
    } finally {
      setLoading(false);
    }
  };

  const { speak } = useSpeechSynthesis();

  const handlePlayback = (text) => {
    try {
      console.log(`Trying to say ${text}`);
      speak({ text });
    } catch (error) {
      console.error('Error during speech synthesis:', error);
    }
  };

  const handleClipboard = () => {
    const itemToCopy = thing.name;
    if (!itemToCopy) {
      return;
    }
    navigator.clipboard.writeText(itemToCopy).then(
      function () {
        alert(`Copied ${itemToCopy} to clipboard`);
      })
      .catch(
        function () {
          alert("Error copying to clipboard!");
        });
  };

  const toggleModal = () => setShowModal(!showModal); // Function to toggle modal visibility

  const handleFormSubmit = async (formData) => {
    // Handle form submission
    try {
      // Dispatch action to create a new thing
      await dispatch(createThing(formData));
      // Close the modal after successful submission
      setShowModal(false);
      toast.success(`Success: ${formData.incomingName} added`);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.error('A thing with the same name already exists.');
      } else {
        console.error('Error submitting form:', error);
        toast.error('An error occurred while submitting the form. Please try again later.');
      }
    }
  };

  return (
    <>
      <Col className="bordered d-grid gap-2">
        <Row className="itemTitle">
          <h2>Things!</h2>
        </Row>
        <Row className="randomThing">
          <Button onClick={handleGetRandomThing} disabled={loading} size="lg">
            {loading ?
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {'Loading...'} </>
              : 'Get Random Thing'}
          </Button>
        </Row>
        <Row className="display">
          {thing && (
            <Button
              variant="info"
            >
              <div>
                <ItemExplainer item={thing} user={userCreator} handlePlayback={handlePlayback} handleClipboard={handleClipboard} />
              </div>
            </Button>
          )}
        </Row>
        <hr />
        <Row>
          <Col>
            {user ? (
              <>
                <Button onClick={toggleModal}>Add your own</Button>
                <Modal show={showModal} onHide={toggleModal}> {/* Modal component with show and onHide props */}
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Thing</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <NewThingForm userId={user._id} onSubmit={handleFormSubmit} closeModal={toggleModal} />
                  </Modal.Body>
                </Modal>
              </>
            ) : (
              <>
              </>
            )}
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default Thing;
